import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterDestroyed', pure: false })
export class FilterDestroyedPipe implements PipeTransform {
  transform(list: any[]): any {
    if (!list || list.length === 0) {
      return list;
    }
    return list.filter((item) => !item._destroy && !item.deleted_at);
  }
}
